<template>
  <transition name="fade">
    <new-message-mobile v-if="isUnReadMessage" />
  </transition>
  <template v-if="type != 'empty'">
    <header>
      <div class="noticeWrap">
        <div class="notice"><em>{{$t('front.common.notices')}}</em><span>{{$t('front.header.msg')}}</span></div>
        <div class="langbtn" @click="openLang()">
          <button class="langdropbtn" >
            <template v-if="$i18n.locale === 'ko'">
              <img src="@/assets_mobile/img/korea.png" /><span class="langsp">KO</span>
            </template>
            <template v-if="$i18n.locale === 'en'">
              <img src="@/assets/img/eng.png" /><span class="langsp">EN</span>
            </template>
            <template v-if="$i18n.locale === 'vn'">
              <img src="@/assets/img/vn.svg" /><span class="langsp">VN</span>
            </template>
            <img class="langbtnb" src="@/assets_mobile/img/langbtn.png" />
          </button>
          <div class="langdropdown" v-if="isOpenLang">
            <a href="#" :class="{'on': $i18n.locale === 'ko'}" @click="changeLocale('ko')">KR</a>
            <a href="#" :class="{'on': $i18n.locale === 'en'}" @click="changeLocale('en')">EN</a>
            <a href="#" :class="{'on': $i18n.locale === 'vn'}" @click="changeLocale('vn')">VN</a>
          </div>
        </div>
      </div>

      <div class="header">
        <div class="tophead">
          <!--
          <div v-if="!userData">
             <a class="mjoinbtn" @click="goPageByName('mobileJoin')">JOIN</a>
             <a class="mloginbtn ml10" @click="goPageByName('mobileLogin')">LOGIN</a>
           </div>
          -->
          <button v-if="!userData" class="m-head-icon user" type="button" aria-label="로그인" @click="goPageByName('mobileLogin')">
            <UserRound :size="17" /><span>로그인</span>
          </button>
          <button v-if="userData" class="m-head-icon user" type="button" aria-label="회원정보" @click="onClickMobileUser">
            <UserRound :size="17" /><span>{{ userData.memNick }}</span>
          </button>
          <div class="logo">
            <a @click="goPageByName('mobileMain')">
              <img class="violet-wordmark" src="@/assets/img/violet17/mega-logo.svg" alt="MEGA" width="264" height="64" />
            </a>
          </div>
          <!-- 오른쪽 햄버거 버튼 -->
          <button
            class="m-head-icon menu"
            type="button"
            aria-label="전체 메뉴"
            :class="{ on: isMobileMenuOpen }"
            @click="toggleMobileMenu"
          >
            <Menu :size="18" />
          </button>
        </div>
        <Teleport to="body">
        <transition name="fade">
          <div
            class="m-menu-dim"
            v-if="isMobileMenuOpen"
            @click.self="closeMobileMenu"
          >
            <div class="m-menu-panel">
              <div class="m-menu-head">
                <button class="m-head-icon user" type="button" aria-label="회원정보" @click="onClickMobileUser">
                  <UserRound :size="17" />
                </button>

                <div class="logo">
                  <a @click="goPageByName('mobileMain'); closeMobileMenu()">
                    <img class="violet-wordmark" src="@/assets/img/violet17/mega-logo.svg" alt="MEGA" width="264" height="64" />
                  </a>
                </div>

                <button class="m-head-icon close" type="button" aria-label="메뉴 닫기" @click="closeMobileMenu">
                  <X :size="18" />
                </button>
              </div>

              <ul class="m-menu-list">
                <li @click="goPageByName('mobileMain')">
                  <em><Spade :size="14" /></em>
                  <span>게임</span>
                </li>
                <li @click="goPageByName('charge')">
                  <em><CircleArrowDown :size="14" /></em>
                  <span>충전</span>
                </li>
                <li @click="goPageByName('exchange')">
                  <em><CircleArrowUp :size="14" /></em>
                  <span>환전</span>
                </li>
                <li @click="goPageByName('betList')">
                  <em><History :size="14" /></em>
                  <span>베팅 기록</span>
                </li>
                <li @click="goPageByName('qnaList')">
                  <em><MessagesSquare :size="14" /></em>
                  <span>1:1문의하기</span>
                </li>
                <li @click="goPageByName('noticeList')">
                  <em><Megaphone :size="14" /></em>
                  <span>공지사항</span>
                </li>
              </ul>
              <div class="m-menu-bottom" v-if="userData">
                <button type="button" class="m-menu-logout" @click="onLogOut">
                  <em>↪</em>
                  <span>로그아웃</span>
                </button>
              </div>
            </div>
          </div>
        </transition>
        </Teleport>
        <!-- <ul class="fxhead">
         <li class="atten" :class="{'on': $route.meta.gnbMenu === 'charge'}"><a @click="goPageByName('charge')"><em></em><span>{{$t('front.common.deposit')}}</span></a></li>
         <li class="notices" :class="{'on': $route.meta.gnbMenu === 'exchange'}"><a @click="goPageByName('exchange')"><em></em><span>{{$t('front.common.withdrawal')}}</span></a></li>
         <li class="home" :class="{'on': $route.meta.gnbMenu === 'betList'}"><a @click="goPageByName('betList')"><em></em><span>{{$t('front.mypage.betList')}}</span></a></li>
         <li class="ques" :class="{'on': $route.meta.gnbMenu === 'cs'}"><a @click="goPageByName('qnaList')"><em></em><span>{{$t('front.common.cscenter')}}</span></a></li>
         <li class="my" :class="{'on': $route.meta.gnbMenu === 'myinfo'}"><a @click="goPageByName('myinfo')"><em></em><span>{{$t('front.common.mypage')}}</span></a></li>
       </ul> -->
      </div>

    </header>
    <nav class="lounge-bottom-nav" aria-label="주요 메뉴">
      <button type="button" @click="openLobbySection('violet-casinos')"><Spade :size="20" /><span>카지노</span></button>
      <button type="button" @click="openLobbySection('violet-slots')"><Gem :size="20" /><span>슬롯</span></button>
      <button type="button" @click="goPageByName('charge')"><CircleArrowDown :size="20" /><span>충전</span></button>
      <button type="button" @click="goPageByName('qnaList')"><MessagesSquare :size="20" /><span>고객센터</span></button>
      <button type="button" @click="toggleMobileMenu"><Menu :size="20" /><span>전체메뉴</span></button>
    </nav>
  </template>
</template>

<script>

import { mapState } from 'vuex'
import NewMessageMobile from '@/components/member/MessageMobile.vue'
import { CircleArrowDown, CircleArrowUp, Gem, History, Megaphone, Menu, MessagesSquare, Spade, UserRound, X } from 'lucide-vue-next'

export default {
  name: 'Header',
  components: { CircleArrowDown, CircleArrowUp, Gem, History, Megaphone, Menu, MessagesSquare, NewMessageMobile, Spade, UserRound, X },
  props: [
    'type'
  ],
  data () {
    return {
      isOpenLang: false,
      isMobileMenuOpen: false
    }
  },
  computed: {
    ...mapState([
      'userData',
      'unReadMessageCount'
    ]),
    isUnReadMessage () {
      return this.unReadMessageCount && this.unReadMessageCount && this.unReadMessageCount !== '0' && this.$route.name.indexOf('message') === -1 && this.$route.name.indexOf('msg') === -1
    }
  },
  unmounted () {
    document.body.style.overflow = ''
  },
  watch: {
    $route () {
      this.closeMobileMenu()
    }
  },
  methods: {
    openLobbySection (id) {
      this.closeMobileMenu()
      const section = document.getElementById(id)
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' })
      else this.$router.push({ name: 'mobileMain', hash: '#' + id, query: this.$route.query })
    },
    onClickMobileUser () {
      this.closeMobileMenu()

      if (this.userData) {
        this.goPageByName('myinfo')
      } else {
        this.onClickLogin()
      }
    },

    toggleMobileMenu () {
      this.isMobileMenuOpen = !this.isMobileMenuOpen

      if (this.isMobileMenuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },

    closeMobileMenu () {
      this.isMobileMenuOpen = false
      document.body.style.overflow = ''
    },
    openLang () {
      this.isOpenLang = !this.isOpenLang
    },
    onLogOut () {
      this.$root.signOut()
      this.$router.push({ name: 'main' })
      // location.reload()
    }
  }
}
</script>

<style scoped src="@/styles_mobile/noir-header.css"></style>
